/**
 * 最新公告 — 只显示最新一条,不存历史。body 用 markdown,react-markdown 渲染。
 */
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

const latest: { date: string; title: string; body: string } = {
  date: '2026-06-13',
  title: '2026 陕西高考关键时间表(官方公告汇总)',
  body: `考试已于 6/7 - 6/9 结束。以下是出分 / 志愿 / 录取的关键节点,基于陕西省教育考试院 2026 年实施办法。

## 📊 成绩公布

**2026 年 6 月 25 日 12:00** 开放查询,同时公布各批次最低控制分数线。

## 📝 志愿填报分两个阶段

### 第一阶段(6/25 12:00 起)

- 本科提前批次 + 职教单招本科:6/25 12:00 — 6/27 12:00
- 本科批次:6/25 12:00 — 6/30 12:00

### 第二阶段(本科投档后)

- 高职(专科)提前批次 + 职教单招高职专科:本科批次正式投档后
- 高职(专科)批次:本科批次录取结束后

## 🎯 录取批次共 4 个

本科提前批 / 本科批 / 高职(专科)提前批 / 高职(专科)批。

## 📚 总分 750

语文 150 + 数学 150 + 外语 150(含听力 30) + 首选物/史 100 + 再选 4 科各 100(等级赋分)。

## 🆕 新高考"3+1+2"

语数外统考 + 1 门首选(物理/历史) + 2 门再选(政治/地理/化学/生物)。

## 📊 2025 年报名 28.15 万人

2026 预计类似,具体以官方为准。

## 🔍 查询入口

- 陕西招生考试信息网 (sneac.com)
- 陕西省教育考试院 (sneea.cn)`,
}

export default function Announcements() {
  return (
    <div>
      <h2 className="serif" style={{ fontSize: 'var(--fs-h1)', fontWeight: 600, lineHeight: 1.15, margin: '0 0 .5rem' }}>
        最新公告
      </h2>
      <p style={{ color: 'var(--ink2)', fontSize: 'var(--fs-body)', marginBottom: '1.5rem' }}>
        出分 / 志愿 / 录取的关键时间点,基于陕西省教育考试院 2026 年实施办法。
      </p>

      <div className="card" style={{ padding: '1.25rem' }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '.75rem', marginBottom: '.75rem', flexWrap: 'wrap' }}>
          <span className="mono" style={{ fontSize: 'var(--fs-capt)', color: 'var(--ink3)' }}>{latest.date}</span>
          <span style={{ fontWeight: 600, fontSize: 'var(--fs-body)' }}>{latest.title}</span>
        </div>
        <div className="md-report" style={{ fontSize: 'var(--fs-body)' }}>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{latest.body}</ReactMarkdown>
        </div>
      </div>
    </div>
  )
}


